var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height mx-0",attrs:{"align":"center"}},[_c('div',{staticClass:"mx-auto"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }